import { Select } from '@app/src/common/Select';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

export const Title = styled.h1`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  font-size: 22px;
  color: ${COLORS.BLACK};
  text-align: center;
  margin-top: 40px;
  padding: 0 15px;

  @media (min-width: ${SIZE.DESKTOP}) {
    font-size: 32px;
    padding: 0;
  }
`;

export const Content = styled.div`
  text-align: center;
  margin-top: 32px;
  padding: 0 15px;

  @media (min-width: ${SIZE.DESKTOP}) {
    padding: 0;
  }
`;

export const Image = styled.img`
  width: 240px;
  display: block;
  margin: 32px auto 25px;
`;

export const ListWrapper = styled.section`
  max-width: 425px;
  margin: 30px auto 25px;
  &> article {
    margin: 0 auto;
  }
  &> article:not(:first-child) {
    margin-top: 40px;
  }

  @media (min-width: 934px) {
    max-width: 890px;
    align-items: center;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    margin: 60px auto 50px;

    &> article:not(:first-child) {
      margin-left: 25px;
      margin-top: 0;
    }

  }
`;

export const SelectWrapper = styled(Select)`
  height: 54px;
  border: 1px solid ${COLORS.BLACK};
  border-radius: 6px;
`;

export const LoaderWrapper = styled.div`
  min-height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Disclaimer = styled.p`
  margin: 30px auto 20px 0;
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
`;